(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('import', {
            parent: 'admin',
            url: '/import',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'import.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/import/import.html',
                    controller: 'ImportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('import');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
